<script>
export default {
  name: "PageNotFound",
  mounted() {
    let currentUrl = new URL(window.location.href);
    let urlList = currentUrl.href.replace(/#[^?]*/, "").split("?", 2);
    let temp = [urlList[0], "#/login?", urlList[1]].join("");
    window.location.href = temp;
  },
};
</script>
